import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { getEmpsExcelIncomeAPI } from '../../../services/employee'
import { fnDateEn } from '../../../helper/fnDateEn'
import Error_false from '../../../components/error/error-false'
import { saveAs } from 'file-saver'
import SwalCustom from '../../../alert/swal-custom'
import { fnDateTh } from '../../../helper/fnDateTh'
import { createSpreadsheetBlob } from '../../../helper/spreadsheet/write-spreadsheet'
import { buildPimIncomeEmployeeReportSheet } from '../../../helper/spreadsheet/pim-employee-reports'
export default function ExportExcel3({
  type_name,
  parame,
  createEmpsExcelLog2
}) {
  const checkDataExport2 = async () => {
    const body = parame
    const resp = await getEmpsExcelIncomeAPI(body)
    if (!resp) return
    if (resp.status) {
      const excels = resp.result.result.map((d, i) => {
        return {
          num: i + 1,
          code: d?.code ?? '-',
          person_id: d?.person_id ?? '-',
          finger_id: d?.finger_id ?? '-',
          level_id: d?.level_id ?? '-',
          sex: d?.sex ?? '-',
          id_card: d?.id_card ?? '-',
          username: d?.username ?? '-',
          title_th: d?.title_th ?? '-',
          name_th: d?.name_th ?? '-',
          surname_th: d?.surname_th ?? '-',
          nickname_th: d?.nickname_th ?? '-',
          title_en: d?.title_en ?? '-',
          name_en: d?.name_en ?? '-',
          surname_en: d?.surname_en ?? '-',
          nickname_en: d?.nickname_en ?? '-',
          division: d?.division ?? '-',
          division_th: d?.division_th ?? '-',
          division_en: d?.division_en ?? '-',
          faction: d?.faction ?? '-',
          faction_th: d?.faction_th ?? '-',
          faction_en: d?.faction_en ?? '-',
          department: d?.department ?? '-',
          department_th: d?.department_th ?? '-',
          department_en: d?.department_en ?? '-',
          team_th: d?.team_th ?? '-',
          team_en: d?.team_en ?? '-',
          position_th: d?.position_th ?? '-',
          position_en: d?.position_en ?? '-',

          start_date_th:
            d.start_date !== '0000-00-00' && d.start_date
              ? fnDateTh(d.start_date).format('DD/MM/YYYY')
              : '-',
          start_date_en:
            d.start_date !== '0000-00-00' && d.start_date
              ? fnDateEn(d.start_date).format('DD/MM/YYYY')
              : '-',

          type: d?.type ?? '-',
          probation: d?.probation ?? '-',
          travelling: d?.travelling ?? '-',
          in_tel: d?.phone_packet ?? '-',
          in_ot: d?.ot_flat_rate ?? '-',
          in_lgn: d?.lang_fee ?? '-',
          in_exp: d?.exp_fee ?? '-',
          in_shift: d?.shift_flat_rate ?? '-'
        }
      })
      const filterEx = resp.result.filters
      await exportExcel2(excels, filterEx)
    } else {
      Error_false(resp)
    }
  }
  const exportExcel2 = async (data, filterEx) => {
    const { sheetData, sheetOptions } = buildPimIncomeEmployeeReportSheet({
      filterEx,
      data
    })
    const blob = await createSpreadsheetBlob(sheetData, sheetOptions)

    saveAs(blob, `Income-Employee.xlsx`)
    await createEmpsExcelLog2(12)
    SwalCustom({
      title: 'Success!',
      text: 'Exported',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500
    })
  }

  return (
    <Dropdown.Item onClick={() => checkDataExport2()}>
      <span
        style={{
          fontSize: '14px'
        }}
      >
        {type_name}
      </span>
    </Dropdown.Item>
  )
}
